{
  "registered": "Registered",
  "pending approval": "Pending approval",
  "not approved": "Not approved",
  "approved": "Approved",
  "cancelled": "Cancelled",
  "out of stock": "Out of stock"
}
